import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Custom translations for Angular Material Paginator.
 * Provides global labels for all paginator instances in the application.
 */
@Injectable()
export class DanishMatPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();

    this.itemsPerPageLabel = 'Indslag per side:';
    this.nextPageLabel = 'Næste side';
    this.previousPageLabel = 'Forrige side';
    this.firstPageLabel = 'Første side';
    this.lastPageLabel = 'Sidste side';
  }

  /**
   * Generates the range label (e.g., "1 – 25 af 100")
   */
  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 af ${length}`;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} – ${endIndex} af ${length}`;
  };
}
